import React from "react";
import "./Help.scss";

const Help = () => {
  return (
    <div className="help">
      <h1>Help</h1>
      <p>Need assistance? Here are some helpful resources:</p>
      <ul>
        <li>FAQ: Frequently Asked Questions</li>
        <li>Contact Us: Reach out to our support team</li>
      </ul>
    </div>
  );
};

export default Help;
